import React, { Component }  from "react";
import '../membershipplan/membershipplan.scss';
import { membershipicon } from "shared/images/images";
// import Footer from "../../layouts/Footer";
import { isAuthorized } from "shared/settings/auth";
import { connect } from "react-redux";
import store from "features/store";
import { useEffect } from "react";
import { pmAutoNavigateToNextScreen } from "shared/utils/utils";
import { addDataLayer } from "shared/utils/utils";

export const MembershipPlan = (props) => {
    useEffect(() => {
        const scrollContainer = document.querySelector('.scroll-content');
        if (scrollContainer) {
            scrollContainer.scrollTop = 0;
        } else {
            window.scrollTo(0, 0);
        }
    }, []);



    const KeyPoint = ({ text }) => (
        <li className="feature-item">
            <i className="far fa-star star-icon"></i>
            <span>{text}</span>
        </li>
    );
    const joinTodayfn = () => {
        if(props.user.suspensionstatus === "ALL"){
            store.dispatch({ type: 'TOGGLE_SUSPEND_MODAL', payload: true });
        }
       else if (props.user.id) {
            pmAutoNavigateToNextScreen(props, props.user, null, null, null, false, true);
            let dataLayerData = {
                'event': 'join_premier',
                'title': 'Premier-TextLink-PMMainOfferPage-Clickhere1'
            }
            addDataLayer(dataLayerData);
        } else {
            store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In', fromBannerBtn: true } });
        }
    };

    const basicPlan = (checkbasicplan) => {
        if(checkbasicplan){
             props.history.push('/');
        }else{
            store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In',basicPlan : true  } });
        }
    }
    

    return (
        <div className="membership-wrapper" >
            {/* Banner */}
            <div className="d-flex justify-content-center">
                
            <div className="membership-banner mt-5">
                <div className="banner-text">
                <img src={`${membershipicon}`} className="membership-icon" />
                    <span>Upgrade to CTBids Premier Membership for $99/year</span>
                </div>
            </div>
            </div>

            {/* Plan Cards */}
            <div className="plan-container mb-5">
                {/* Basic Plan */}
                <div className="basic-plan mt-3">
                    <div className="d-flex align-items-center mt-4">
                        <div className="basic-marker"></div>
                        <h3  style={{ margin: 0 }} className="plan-heading ">CTBids Basic Plan</h3>
                    </div>
                    <p className="price mt-3 mb-3">Free</p>
                    <button  onClick={() => basicPlan(true)} className="basic-button">Continue with Basic Plan</button>
                    <div className="mb-5">
                        <KeyPoint text="Supported by Caring Transitions" />
                        <KeyPoint text="Proxy bidding feature" />
                        <KeyPoint text="24/7 available helpdesk" />
                        <KeyPoint text="Real time bid status notification" />
                    </div>
                </div>

                {/* Premier Plan */}
                <div className="premier-plan mt-3">
                    <div className="d-flex align-items-center mt-4">
                        <div className="premier-marker" ></div>
                        <h3 style={{ margin: 0 }}>CTBids Premier Plan</h3>
                    </div>

                    <div>
                    <div className="sub-price mt-3 mb-3 d-flex align-items-center">
                        <span className="price">$99</span> 
                        <p>per year or $10 every month</p>
                    </div>
                    </div>
                   
                    <button  onClick={(e) => { joinTodayfn(); }} className="premier-button">Upgrade to CTBids Premier</button>
                    <div>
                        <KeyPoint text="Supported by Caring Transitions" />
                        <KeyPoint text="Proxy bidding feature" />
                        <KeyPoint text="24/7 dedicated customer relationship manager" />
                        <KeyPoint text="Real time bid status notification" />
                        <hr />
                        <KeyPoint text="No need to worry about porch piracy" />
                        <KeyPoint text="Free gifts on each win" />
                        <KeyPoint text="Free WorthPoint Subscription" />
                        <KeyPoint text="Early viewing for each auction" />
                        <KeyPoint text="Become CTBids Patron/advisor" />
                    </div>
                </div>
            </div>
            {/* <div className="mt-3">
                    <Footer className={'remove-bottom'}{...props} />
                </div> */}
        </div>
    );
};


class VipMembershipPlan extends Component {
    constructor(props) {
        super(props);
    }


    render() {
        return <MembershipPlan {...this.props} />
    }
}

export default connect(state => state)(VipMembershipPlan);
